import { json } from 'react-router-dom'
import Axois from '../utils/axios'
import EventEmitter from '../utils/eventEmitter';



export const loadAnalyticAccounts = async () => {
  let response = await Axois.get('/analytic-accounts').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
    const responseData = await response.data;
    return responseData;
  // return [];
}


export const loadAnalyticAccount = async (action) => {
  try {
    switch (action) {
      case 'new':
        let requests = await Axois.get('/setups/analytic-accounts');
        const responseData = await requests.data;
        return {...responseData, analytic: {}};
        // return { positions: [], budgets: [], analytic: {}};
      
      default:
        let response = await Axois.get('/analytic-accounts/'+action);
        const responseJson = await response.data;
        return responseJson;
        // return { positions: [], budgets: [], analytic: {}};
    }
  }catch (err) {
    console.log(err);
  }
}



const useAnalyticAccountAPI = () => {
  
  const save = async (data, success) => {
    try {
      const response = await Axois.post('/analytic-accounts', data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('analytic_response', data.seo);
    }catch(err) {
      console.log(err);
    }
  };


  const update = async (seo, data, success) => {
    try {
      const response = await Axois.put('/analytic-accounts/'+seo, data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('analytic_response', data.seo);
    }catch (err) {
      console.log(err);
    }
  }

  return { save, update };
}


export default useAnalyticAccountAPI;